import React, { useEffect, useState } from 'react';
import { HGTable } from 'components/HGTable';
import { useGetIDsFromURL } from '../helper';
import { useDeviceStats } from 'components/DeviceDetails/service';

const columns = [
    { Header: 'Serial Number', accessor: 'serialNumber' },
    { Header: 'Status', accessor: 'status' },
];

const ValidateDevices = ({ gateway, devices }) => {
    const [devicesWithStatuses, setDevicesWithStatuses] = useState([]);
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);
    const { Thing_ID } = useGetIDsFromURL();
    const { data: stats } = useDeviceStats(Thing_ID ?? gateway?.Thing_ID);

    useEffect(() => {
        if (devices && devicesWithStatuses.length === 0 && stats) {
            const verifiedSerialNumbers = Object.keys(stats);
            const statuses = devices.map((device) => ({
                ...device,
                status: verifiedSerialNumbers.includes(device.serialNumber)
                    ? 'online'
                    : 'offline',
            }));
            setDevicesWithStatuses(statuses);
        }
    }, [devices, devicesWithStatuses, stats]);

    return (
        <div className="p-5">
            <HGTable
                columns={columns}
                data={devicesWithStatuses}
                sortField={sortField}
                setSortField={setSortField}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                currentPage={1}
                setCurrentPage={() => {}}
                pageSize={devicesWithStatuses.length}
                totalItems={devicesWithStatuses.length}
            />
        </div>
    );
};

export default ValidateDevices;
